import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import type { TrustSignalDisplay } from './trustSignal.utils';
import { getTrustSignalDisplay } from './trustSignal.utils';
import { trustSignalSegment, trustSignalSeparator, trustSignalText } from './trustSignal.styles';

type TrustSignalProps = {
  // When provided, skips the internal selector. Lets parents (e.g. SummaryRow)
  // compute the display once and reuse it for the gate decision.
  display?: TrustSignalDisplay;
};

export const TrustSignal = ({ display: displayProp }: TrustSignalProps = {}) => {
  const listing = useSelector((state: RootReduxState) => state.currentListingDetails?.currentListing);
  const { listedText, listedIso, updatedText, updatedIso, showListed, showUpdated } =
    displayProp ?? getTrustSignalDisplay(listing?.history);

  if (!showListed && !showUpdated) {
    return null;
  }

  return (
    <p data-testid="text-trust-signal" className={trustSignalText}>
      {showUpdated && (
        <span className={trustSignalSegment}>
          {updatedIso ? <time dateTime={updatedIso}>{updatedText}</time> : <span>{updatedText}</span>}
        </span>
      )}
      {showListed && (
        <span className={trustSignalSegment}>
          {showUpdated && (
            <span className={trustSignalSeparator} aria-hidden="true">
              ·
            </span>
          )}
          {listedIso ? <time dateTime={listedIso}>{listedText}</time> : <span>{listedText}</span>}
        </span>
      )}
    </p>
  );
};
